import React from 'react';

import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Domain from '@mui/icons-material/Domain';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import logo from './logo.svg';
import { Counter } from './features/counter/Counter';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import { Home } from './home/page';
import DrawerContent from './app/DrawerContent';
import RightBox from './features/appbar/RightBox';
import './App.css';


const drawerWidth = 240;
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme, open }) => ({
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: 'nowrap',
		boxSizing: 'border-box',
		...(open && {
			...openedMixin(theme),
			'& .MuiDrawer-paper': openedMixin(theme),
		}),
		...(!open && {
			...closedMixin(theme),
			'& .MuiDrawer-paper': closedMixin(theme),
		}),
	}),
);

const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0, 1),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
	open?: boolean;
}

const AppBar = styled(
	MuiAppBar,
	{shouldForwardProp: (prop) => prop !== 'open',}
)<AppBarProps>(
({ theme, open }) => ({
	zIndex: theme.zIndex.drawer + 1,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

const contentStyle = {
	height: `calc(100% - 49px)`,
	width: '100%',
	//backgroundColor: 'red',
};

export function AppLeftDrawer() {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);


	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	return (
		<Box sx={{ display: 'flex', height: '100vh', margin: 0}}>
			<CssBaseline />
			<AppBar position="fixed" open={open}>
				<Toolbar>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						onClick={handleDrawerOpen}
						edge="start"
						sx={{
							marginRight: 5,
							...(open && { display: 'none' }),
						}}
					>
						<MenuIcon />
					</IconButton>
					<Box flex={1}>
						<Typography variant="h6" noWrap component="div">
							 {/*Protostructure*/}
						</Typography>
					</Box>
					<RightBox />
				</Toolbar>
			</AppBar>

			<Drawer variant="permanent" open={open}>
				<DrawerHeader>
					<IconButton onClick={handleDrawerClose}>
						{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
					</IconButton>
				</DrawerHeader>
				<Divider />
				<DrawerContent open={open} />
			</Drawer>
			<Box component="main" sx={{ flexGrow: 1, p: 0, margin: 0, height: '100vh'}}>
				<DrawerHeader />
				<Box sx={contentStyle}>
					<Outlet />
				</Box>
			</Box>
		</Box>
	);
}

/*
   <Box position="fixed" sx={
   {backgroundColor: 'blue',
display: 'flex',
height: 55,
width: '100%',
paddingLeft: 6,
paddingRight: 10,
alignItems: 'center',
}}>
<Box sx={{flexGrow: 1, backgroundColor: 'green'}}>
<Typography>yo</Typography>
</Box>
<Box sx={{flexGrow: 4, backgroundColor: 'yellow'}}>
<Typography>ya</Typography>
</Box>
</Box>
<Box sx={{height: 55}}>
</Box>
function AppLeftDrawer() {
return (
<div>
<img src={logo} className="App-logo" alt="logo" />
<HeadNavigation />
</div>
);
}

function HeadNavigation() {
return (
<div>
<p>this is navigation</p>
<Link to="/">Home</Link>
<Link to="/counter">Counter</Link>
<Link to="/user">User</Link>
<Outlet />
</div>
);
}
//export default App;
// */
export default AppLeftDrawer;
